export default __webpack_public_path__ + "static/media/jose--mobile@2x.a17e1ca2.jpg";